import BgImg from '@assets/jpg/signup-bgs/step-2.jpeg';
import { Paper } from '@components/ui';
import { useAppDispatch } from '@hooks/app/redux';
import { actions as authActions } from '@store/ducks/auth';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link, RouteChildrenProps } from 'react-router-dom';
import AuthLayout from '../components/auth-layout';
import Header from '../components/header';
import LoginForm from './components/login-form';

const Login: React.FC<RouteChildrenProps> = () => {
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    dispatch(authActions.getTryLoginRequest());
  }, [dispatch]);

  return (
    <AuthLayout backgroundImage={BgImg}>
      <div className="form-wrapper login">
        <Header textId="login.title" />
        <div className="form right-content">
          <LoginForm />
          <div className="auth-login-bottom">
            <Link to="/reset-password" className="auth-forgot-link">
              <FormattedMessage id="login.forgot_password" />
            </Link>
            <FormattedMessage
              tagName={'span'}
              id="login.no_account"
              values={{
                link1: (
                  <Link to="/registration" className="auth-reg-link">
                    <FormattedMessage id="login.register" />
                  </Link>
                ),
              }}
            />
          </div>
        </div>
      </div>
    </AuthLayout>
  );
};

export default Login;
